import type { ReactNode } from "react";
import engageAppIcon from "./engage-app-icon.png";

export interface EngageLogoProps {
  readonly name: string;
  readonly subtitle: string;
}

/**
 * Compact C3I identity. The existing export remains stable for shell consumers.
 * Its parent supplies the accessible name; the established Engage icon remains unchanged.
 */
export function EngageLogo({ name, subtitle }: EngageLogoProps): ReactNode {
  return (
    <span aria-hidden="true" className="engage-logo">
      <img
        alt=""
        className="engage-logo__icon"
        height="32"
        src={engageAppIcon}
        width="32"
      />
      <span className="engage-logo__copy">
        <strong className="engage-logo__wordmark">{name}</strong>
        <span className="engage-logo__subtitle">{subtitle}</span>
      </span>
    </span>
  );
}
